__turbopack_context__.v({
  "container": "ScrollableWithType-module-scss-module__0AP2HW__container",
  "list": "ScrollableWithType-module-scss-module__0AP2HW__list",
  "spacer": "ScrollableWithType-module-scss-module__0AP2HW__spacer",
});
